var _title, _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 -2.5 64 64",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), "\r\n    {title === undefined ? (\r\n      ", title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "{titleId}"
  }, "{\"Thumb-down\"}") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "{titleId}"
  }, title) : null, "\r\n    ) : title ? (\r\n      ", _title || (_title = /*#__PURE__*/React.createElement("title", {
    id: "{titleId}"
  }, "{title}")), "\r\n    ) : null}\r\n    ", _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "{\"Created with Sketch.\"}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Thumb-down",
    transform: "translate(2.000000, 1.000000)",
    stroke: "#6B6C6E",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43,36 L58.1,36 C60.9,36 61,33.9 61,31.2 L61,6.9 C61,4.3 60.9,2.1 58.1,2.1 L43,2.1 C40.2,2.1 40.1,4.2 40.1,6.9 L40.1,31.2 C40.1,33.8 40.2,36 43,36 L43,36 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3,5.7 L38.9,5.7 C35.1,5.8 32.6,0 29.7,0 L7.1,0 C4.3,0 3.7,4.2 3.8,6 C3.8,6 0.3,7.6 1.9,14 C1.7,14.1 -0.1,15.8 -0.1,19.1 C-0.1,22.4 1.8,24 1.8,24 C1.8,24 -0.1,26.1 -0.1,29.2 C-0.1,32.3 2.6,34 5.4,34 L13.7,34 C20.9,34 20.3,37.9 20.3,37.9 C20.3,37.9 21.1,48 23.7,52.7 C26.9,58.5 33.3,56.6 30.9,49 C29.1,43.4 37.2,35 40.2,32.2",
    id: "Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDown);
export default __webpack_public_path__ + "static/media/thumb-down.1397c4514be17ddeb919ffe3d4fef7fc.svg";
export { ForwardRef as ReactComponent };